/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal } from '../../twd'
import Header from './header'
import Grid from './grid'
import useDepthOfMarket from './use-depth-of-market'

export default ({cusip, allowTrading}) => {

    const { issueData, askRows, bidRows } = useDepthOfMarket({cusip})

    return <React.Fragment>
    <div className="modal-dialog modal-lg">
    <div className="modal-content">

    <div className="container" style={{background:"#ffffff" }}>
        <div className="row"><div className="col-md-12">
        <div className="vertical-offset-md"></div>
        <button
            className="close"
            aria-label="close"
            data-name="offerings-depth-of-market-close"
            type="button"
            onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>

        </div></div>

        <div className="row"><div className="col-md-12 text-center">
            <h2>Depth of Market</h2>
        </div></div>

        <Header cusip={cusip} {...issueData} />
    </div>

    <div className="container" style={{
        background: '#ffffff',
        border: 'solid 1px #e4e4e4',
        padding: '10px'
    }}>
        <div className="row">
        <div className="col-md-6 col-xs-12">
            <Grid type='bid' rows={bidRows} allowTrading={allowTrading} />
        </div>
        <div className="col-md-6 col-xs-12">
            <Grid type='ask' rows={askRows} allowTrading={allowTrading} />
        </div>
        </div>
    </div>

    </div>
    </div>
    </React.Fragment>
}




// WEBPACK FOOTER //
// ./src/offerings/depth-of-market/depth-of-market.js